(ns app.front.view.group.admin.payment
  (:require [app.domain.payment.provider.model :as pp-model]
            [app.front.entities :as entities]
            [app.front.ui :as ui]
            [app.front.ui.multi-select :as ui-ms]
            [app.front.ui.select :as ui-select]
            [app.front.util :refer [for-frag] :as futil]
            [app.front.view.group.admin.common :as acommon]
            [app.front.view.group.admin.core :as core]
            [app.front.view.group.admin.fees.payment.payment-core :as payment-management]
            [app.front.view.group.admin.subs :as gas]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.icons :as i]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]
            [schema-tools.core :as st]
            [schema.core :as s]))

;;TODO completely remove legacy Moneris once all use has ceased
(def deprecated-services {:payment-service/moneris "Moneris Hosted Payment Page is retiring. Please use the new Moneris Checkout instead."})

(rf/reg-event-db ::toggle-edit-payment-conf
  (fn [db _]
    (update db ::edit-payment-conf? not)))


(rf/reg-sub ::edit-payment-conf?
  (fn [db _]
    (-> db ::edit-payment-conf?)))


(defn deprecated-info [notice]
  (when notice
    (ui/help notice)))


(defn help-text-block [tr-quiet help-text]
  (when (or (string? help-text)
            (keyword? help-text))
    [:div.whitespace-pre-line.text-xs.my-2.text-gray-600 (or (tr-quiet [help-text]) help-text)]))


(defn view-row [key label value help-texts]
  (let [help-text          (get help-texts (if (s/optional-key? key) (:k key) key))
        help-text-by-value (get help-text value)
        tr-quiet           (<sub [:tr/quiet])]
    [:div.bx--row.mb-3
     [:div.bx--col-xs-12.bx--col-lg-6
      [:div.font-bold.my-4 (or (tr-quiet [(keyword "payment.config" (name label))]) label)]
      [:div
       ;; show select options as given in model
       (if (and (map? help-text) help-text-by-value)
         help-text-by-value
         (cond
           (boolean? value) (if value "yes" "no")
           (set? value) (->> value
                             (map (comp tr-quiet vector))
                             sort
                             (str/join ", "))
           :else value))]
      (help-text-block tr-quiet help-text)]]))

(defn- escrow-info [domain-group? tr provider]
  (when (and domain-group?
             (not (pp-model/escrow-deposit-supported? provider)))
    [ui/help (tr [:payment.config/escrow-deposit-unsupported-info])]))

(defn payment-method-form-view [{:keys [:payment-method/config
                                        :payment-method/handler
                                        :payment-method/max-amount
                                        :payment-method/convenience-fee-percentage
                                        :payment-method/convenience-fee-fixed]}
                                tr
                                domain-group?]
  (let [current-provider handler
        schema           (pp-model/provider->schema current-provider)
        help-text        (pp-model/provider->help-text current-provider)
        deprecated       (deprecated-services handler)]
    [:form
     [:div.mb-6
      [:h3.mb-4 (tr [:payment.config/service])]
      [:div.mb-8 (tr [current-provider])]
      [escrow-info domain-group? tr current-provider]]
     [:h3.mb-4 (tr [:payment.config/configuration])]
     [deprecated-info deprecated]
     (for-frag [k (keys schema)]
       [view-row k (name (if (s/optional-key? k) (:k k) k)) (st/get-in config [k]) help-text])
     (when (pp-model/convenience-fees-supported? current-provider)
       [:div
        [view-row nil (tr [:payment.config/convenience-fee-percentage])
         (if convenience-fee-percentage
           (futil/parse-float convenience-fee-percentage)
           (tr [:payment.config/convenience-fee-percentage-not-set]))
         help-text]
        [view-row nil (tr [:payment.config/convenience-fee-fixed])
         (if convenience-fee-fixed
           (futil/parse-float convenience-fee-fixed)
           (tr [:payment.config/convenience-fee-fixed-not-set]))
         help-text]])
     [view-row nil (tr [:payment.config/online-payment-limit])
      (if max-amount
        (/ (futil/parse-int max-amount) 100)
        (tr [:payment.config/online-limit-not-set]))
      help-text]
     [:div.bx--row.mt-4
      [:div.bx--col-xs-12..bx--col-lg-6.flex.justify-end
       (cc/button
         {:kind     :tertiary
          :on-click #(>evt [::toggle-edit-payment-conf])}
         (tr [:edit]))]]]))

(defn- valid-decimal-string?
  "Will the given string parse as a bigdec?"
  [str]
  (and (string? str) (re-matches #"\d+(.\d+)?" str)))

(defn payment-method-form [group-id method tr tr-quiet domain-group?]
  (r/with-let [initial-config (select-keys method [:payment-method/config
                                                   :payment-method/handler
                                                   :payment-method/max-amount
                                                   :payment-method/convenience-fee-percentage
                                                   :payment-method/convenience-fee-fixed])
               *config-atom   (r/atom initial-config)]
    (let [current-provider           (-> @*config-atom :payment-method/handler)
          schema                     (pp-model/provider->schema current-provider)
          help-text                  (pp-model/provider->help-text current-provider)
          required-fields            (-> @*config-atom
                                         :payment-method/config
                                         (select-keys (->> schema keys (filter s/required-key?))))
          all-fields                 (-> @*config-atom
                                         :payment-method/config
                                         (st/select-keys (->> schema keys)))
          invalid?                   (some? (some-> schema (s/check required-fields)))
          max-amount                 (get @*config-atom :payment-method/max-amount)
          max-amount-invalid?        (and max-amount (< max-amount 1))
          invalid-bigdec?            (fn [str]
                                       (and str
                                            (or (str/blank? str)
                                                (not (valid-decimal-string? str))
                                                (<= (double str) 0))))
          convenience-perc           (get @*config-atom :payment-method/convenience-fee-percentage)
          convenience-perc-invalid?  (invalid-bigdec? convenience-perc)
          convenience-fixed          (get @*config-atom :payment-method/convenience-fee-fixed)
          convenience-fixed-invalid? (invalid-bigdec? convenience-fixed)
          deprecated                 (deprecated-services current-provider)]
      [:form.admin-config-form.payment-provider-config
       [:div.mb-6
        [:h3.mb-4 (tr [:payment.config/service])]
        [ui-select/select {:id           "payment-system-type"
                           :class-name   "w-full lg:w-1-3"
                           :value        current-provider
                           :on-change    #(swap! *config-atom assoc :payment-method/handler %)
                           :values       (sort (keys pp-model/provider->schema))
                           :val->str     (comp tr vector)
                           :allow-empty? false}]]
       [escrow-info domain-group? tr current-provider]
       [:h3.mb-4 (tr [:payment.config/configuration])]
       [deprecated-info deprecated]
       (for-frag [[k v] schema
                  :let [k                 (if (s/optional-key? k) (:k k) k)
                        is-enum?          (instance? s/EnumSchema v)
                        is-integer?       (= (:pred-name v) 'integer?)
                        is-boolean?       (= js/Boolean v)
                        help-text-current (get help-text k)
                        opts              {:label-text (or (tr-quiet [(keyword "payment.config" (name k))]) (name k))
                                           :id         (str (:db/id method) "." (name k))
                                           :value      (get-in @*config-atom [:payment-method/config k])}
                        swap-fn           (fn [val-fn]
                                            #(swap! *config-atom
                                                    assoc-in
                                                    [:payment-method/config k]
                                                    (val-fn %)))]]
         [:div.bx--row.mb-2
          [:div.bx--col-xs-12.bx--col-lg-6
           (cond is-integer?
                 [ui/number-input
                  (assoc opts
                         :on-change
                         (swap-fn #(-> % futil/tval futil/parse-int)))]

                 is-enum?
                 [ui-select/select
                  (merge opts
                         {:allow-empty? false
                          :class-name   "select-w-full"
                          :values       (:vs v)
                          :val->str     #(get help-text-current %)
                          :on-change    (swap-fn #(cond-> %
                                                    (-> v :vs first :val integer?) futil/parse-int))})]

                 is-boolean?
                 (cc/checkbox
                   (-> opts
                       (select-keys [:label-text :id])
                       (merge {:checked   (-> opts :value boolean)
                               :on-change (swap-fn boolean)})))

                 (and (set? v) (instance? s/EnumSchema (first v)))
                 [:div
                  [:div.bx--label (:label-text opts)]
                  [ui-ms/multi-checkbox {:tr        tr
                                         :values    (-> v first :vs sort)
                                         :selected  (-> opts :value set)
                                         :val->str  (comp tr vector)
                                         :on-change (swap-fn identity)}]]

                 :else
                 [ui/text-input
                  (assoc opts
                         :on-change
                         (swap-fn #(-> % futil/tval str/trim)))])
           (help-text-block tr-quiet help-text-current)]])

       (when (pp-model/convenience-fees-supported? current-provider)
         [:div
          [:div.bx--row.mb-2
           [:div.bx--col-xs-12.bx--col-lg-6.flex
            [:div
             [ui/text-input {:id           "convenience-percentage"
                             :label-text   (tr [:payment.config/convenience-fee-percentage])
                             :invalid      convenience-perc-invalid?
                             :invalid-text (when convenience-perc (tr [:payment.config/convenience-fee-percentage-invalid]))
                             :value        convenience-perc
                             :on-change    #(swap! *config-atom assoc :payment-method/convenience-fee-percentage (futil/tval %))}]
             (when (->> :payment-method/convenience-fee-percentage (get help-text) keyword?)
               [:div.whitespace-pre-line.text-xs.my-2.text-gray-600
                (tr [(get help-text :payment-method/convenience-fee-percentage)])])]
            [:div.text-left.mt-4.-ml-2
             (cc/button
               {:kind             :ghost
                :disabled         (not convenience-perc)
                :icon             i/remove
                :icon-description (tr [:payment.config/clear-convenience-fee-percentage])
                :title            (tr [:payment.config/clear-convenience-fee-percentage])
                :on-click         #(swap! *config-atom
                                          dissoc
                                          :payment-method/convenience-fee-percentage)}
               (tr [:clear]))]]]
          [:div.bx--row.mb-2
           [:div.bx--col-xs-12.bx--col-lg-6.flex
            [:div
             [ui/text-input {:id           "convenience-fixed"
                             :label-text   (tr [:payment.config/convenience-fee-fixed])
                             :invalid      convenience-fixed-invalid?
                             :invalid-text (when convenience-fixed (tr [:payment.config/convenience-fee-fixed-invalid]))
                             :value        convenience-fixed
                             :on-change    #(swap! *config-atom assoc :payment-method/convenience-fee-fixed (futil/tval %))}]
             (when (->> :payment-method/convenience-fee-fixed (get help-text) keyword?)
               [:div.whitespace-pre-line.text-xs.my-2.text-gray-600
                (tr [(get help-text :payment-method/convenience-fee-fixed)])])]
            [:div.text-left.mt-4.-ml-2
             (cc/button
               {:kind             :ghost
                :disabled         (not convenience-fixed)
                :icon             i/remove
                :icon-description (tr [:payment.config/clear-convenience-fee-fixed])
                :title            (tr [:payment.config/clear-convenience-fee-fixed])
                :on-click         #(swap! *config-atom
                                          dissoc
                                          :payment-method/convenience-fee-fixed)}
               (tr [:clear]))]]]])

       [:div.bx--row.mb-2
        [:div.flex.items-end.px-2
         [ui/number-input {:id           "max-amount"
                           :label-text   (tr [:payment.config/max-amount])
                           :min          1
                           :invalid      max-amount-invalid?
                           :invalid-text (when max-amount-invalid? (tr [:payment.config/max-amount-invalid]))
                           :value        (when max-amount (/ (futil/parse-int max-amount) 100))
                           :step         1
                           :on-change    #(swap! *config-atom
                                                 assoc
                                                 :payment-method/max-amount
                                                 (-> % futil/tval js/parseInt (* 100)))}]
         [:div.pb-2
          (cc/button
            {:kind             :ghost
             :size             :field
             :disabled         (not max-amount)
             :icon             i/remove
             :icon-description (tr [:payment.config/clear-max-amount])
             :title            (tr [:payment.config/clear-max-amount])
             :on-click         #(swap! *config-atom
                                       dissoc
                                       :payment-method/max-amount)}
            (tr [:clear]))]]]
       [:div.bx--row.mt-4
        [:div.bx--col-xs-12.bx--col-lg-6.flex.justify-end
         (cc/button
           {:kind       :tertiary
            :class-name "mr-2"
            :on-click   #(do
                           (>evt [::toggle-edit-payment-conf])
                           (reset! *config-atom initial-config))}
           (tr [:cancel]))
         [ui/modal-confirmation-button
          {:tr                  tr
           :id                  "save-config"
           :trigger-button-opts {:kind     :primary
                                 :disabled (or (= initial-config @*config-atom)
                                               invalid?)}
           :trigger-button-text (tr [:save])
           :on-yes-click        #(do
                                   (>evt [::toggle-edit-payment-conf])
                                   (>evt [::core/save-payment-config
                                          group-id
                                          (:db/id method)
                                          (p/assoc-if {:payment-method/handler current-provider
                                                       :payment-method/config  all-fields}
                                                      :payment-method/max-amount max-amount
                                                      :payment-method/convenience-fee-percentage convenience-perc
                                                      :payment-method/convenience-fee-fixed convenience-fixed)]))}
          [:div (tr [:payment.config/confirm-modal])]]]]])))

(defn view [match]
  (let [tr             (<sub [:tr])
        tr-quiet       (<sub [:tr/quiet])
        group-id       (-> match :parameters :path :group-id)
        payment-method (<sub [::entities/entity {:domain/authority-group group-id
                                                 :entity/type            :entity.type/payment-method
                                                 :payment-method/type    :payment-method/online-card}])
        domain-group?  (= (<sub [::gas/group-type]) :group.type/domain)]
    [acommon/admin-page-v2
     {:match match
      :title (tr [:payment.config/title])}
     [:div
      (when domain-group?
        ;; Domain groups do not have fee-schedules, so the normal way to configure payments is not possible.
        ;; Payment system is needed for topping up escrow accounts.
        [:section
         [payment-management/online-payment-toggle tr group-id payment-method]])
      (when (:payment-method/config payment-method)
        [:section {:key group-id}
         [:div
          [:h2 (tr [:payment.config/configure-payment-page])]
          [ui/help (tr [:payment.config/warning])]]
         ^{:key (:db/id payment-method)}
         (if (<sub [::edit-payment-conf?])
           [payment-method-form group-id payment-method tr tr-quiet domain-group?]
           [payment-method-form-view payment-method tr domain-group?])])]]))

(def route
  {:name        :view/group.admin.payment
   :own-layout? true
   :view        view})
